module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "user",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-left"
  }, [(_vm.isUserAdmin) ? _c('div', {
    staticClass: "row"
  }, [(!_vm.isBlocked) ? _c('z-button', {
    attrs: {
      "accent": "",
      "fitContent": ""
    },
    on: {
      "click": _vm.block
    }
  }, [_vm._v("Заблокировать")]) : _vm._e(), _vm._v(" "), (_vm.isBlocked) ? _c('z-button', {
    attrs: {
      "accent": "",
      "fitContent": ""
    },
    on: {
      "click": _vm.unblock
    }
  }, [_vm._v("Разблокировать")]) : _vm._e(), _vm._v(" "), (!_vm.isAuthOff) ? _c('z-button', {
    attrs: {
      "accent": "",
      "fitContent": ""
    },
    on: {
      "click": _vm.authoff
    }
  }, [_vm._v("Сбросить авторизацию")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "header-center"
  }), _vm._v(" "), _c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "name": "fio",
      "id": "fio",
      "label": "ФИО",
      "required": true,
      "error": _vm.errors.first('fio'),
      "data-vv-as": " "
    },
    model: {
      value: (_vm.user.fio),
      callback: function($$v) {
        _vm.$set(_vm.user, "fio", $$v)
      },
      expression: "user.fio"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        alpha_dash: true
      }),
      expression: "{required: true, alpha_dash: true}"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "login",
      "id": "login",
      "label": "Логин",
      "required": true,
      "error": _vm.errors.first('login'),
      "data-vv-as": " "
    },
    on: {
      "blur": _vm.setEmail
    },
    model: {
      value: (_vm.user.login),
      callback: function($$v) {
        _vm.$set(_vm.user, "login", $$v)
      },
      expression: "user.login"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true
      }),
      expression: "{required: true, email: true}"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "email",
      "id": "email",
      "label": "Email",
      "required": true,
      "error": _vm.errors.first('email'),
      "data-vv-as": " "
    },
    on: {
      "blur": _vm.setEmail
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  })], 1), _vm._v(" "), _c('multy-autocomplete', {
    attrs: {
      "id": "groups",
      "name": "groups",
      "placeholder": "Группа",
      "label": "Группа",
      "display-property": "name",
      "property": "id",
      "return": "id",
      "items": _vm.usersGroups,
      "showOnFocus": true,
      "show-search-input": false
    },
    model: {
      value: (_vm.user.groups),
      callback: function($$v) {
        _vm.$set(_vm.user, "groups", $$v)
      },
      expression: "user.groups"
    }
  }), _vm._v(" "), (_vm.user && _vm.user.id) ? _c('div', {
    staticClass: "avatar-container"
  }, [(_vm.user.avatar) ? _c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.$root.staticEndpoint + _vm.user.avatar
    }
  })]) : _vm._e(), _vm._v(" "), _c('z-input-image', {
    attrs: {
      "imgHeightMin": 60,
      "imgWidthMin": 60,
      "imgHeightMax": 300,
      "imgWidthMax": 300,
      "name": "avatar",
      "placeholder": "Аватар",
      "label": "Аватар",
      "buttonText": "Загрузить аватар",
      "width": "200px",
      "show-label": false,
      "link": (_vm.$root.endpoint + '/user/' + _vm.user.id + '/avatar/save')
    },
    on: {
      "complete": _vm.getUser
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('toggle-card', {
    attrs: {
      "heading": "Изменение пароля"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !_vm.user.id
      }),
      expression: "{required: !user.id}"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "password",
      "id": "password",
      "label": "Пароль",
      "required": true,
      "type": "password",
      "error": _vm.errors.first('password'),
      "data-vv-as": " "
    },
    model: {
      value: (_vm.user.password),
      callback: function($$v) {
        _vm.$set(_vm.user, "password", $$v)
      },
      expression: "user.password"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: !!_vm.user.password
      }),
      expression: "{required: !!user.password}"
    }],
    staticClass: "col-6",
    attrs: {
      "name": "password_confirm",
      "id": "password_confirm",
      "label": "Подтверждение пароля",
      "required": true,
      "type": "password",
      "error": _vm.errors.first('password_confirm'),
      "data-vv-as": " "
    },
    model: {
      value: (_vm.user.password_confirm),
      callback: function($$v) {
        _vm.$set(_vm.user, "password_confirm", $$v)
      },
      expression: "user.password_confirm"
    }
  })], 1), _vm._v(" "), (_vm.user.email && (_vm.user.email.indexOf('@') + 1)) ? _c('z-check', {
    attrs: {
      "id": "send_email",
      "name": "send_email",
      "label": "Отправить пользователю пароль на Email",
      "value": true
    },
    model: {
      value: (_vm.user.send_email),
      callback: function($$v) {
        _vm.$set(_vm.user, "send_email", $$v)
      },
      expression: "user.send_email"
    }
  }) : _vm._e()], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da92b62","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/User.vue
// module id = 1058
// module chunks = 0